export const registerFields = [
  ['company', 'address1', 'city', 'region', 'zip', 'phone', 'country', 'reCaptcha'],
  ['email', 'password', 'confirmPassword', 'firstName', 'lastName', 'title', 'terms'],
  ['billingName', 'billingEmail', 'billingPhone', 'emailForInvoices'],
  ['podcastName', 'podcastUrl', 'podcastCampaign', 'podcastSourceId'],
];
